import { useState } from 'react';
import { useDebouncedValue } from './useDebouncedValue';

const DEBOUNCE_MS = 250;
const MIN_LENGTH = 3;

/** Debounced search-box state: `q` is undefined until the trimmed, debounced input reaches MIN_LENGTH chars. */
export function useSearchQuery() {
  const [input, setInput] = useState('');
  const debounced = useDebouncedValue(input.trim(), DEBOUNCE_MS);
  const q = debounced.length >= MIN_LENGTH ? debounced : undefined;
  return { input, setInput, q };
}
